import Highcharts from 'highcharts';

import { colors } from 'styles/theme/colors';

import { NetworkPerformanceEntityRow } from '../useNetworkPerformanceSlideoutAnalytics';

type ColumnChartParams = {
  entityRows: NetworkPerformanceEntityRow[];
  seriesName: string;
  color: string;
  yAxisFormat?: string;
  yAxisAllowDecimals?: boolean;
  tooltipFormatter?: Highcharts.TooltipFormatterCallbackFunction;
};

export function buildColumnChartOptions({
  entityRows,
  seriesName,
  color,
  yAxisFormat,
  yAxisAllowDecimals,
  tooltipFormatter,
}: ColumnChartParams): Highcharts.Options {
  return {
    chart: { type: 'column', style: { fontFamily: 'Lato' }, height: 280 },
    accessibility: { enabled: false },
    credits: { enabled: false },
    title: { text: undefined },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      symbolRadius: 6,
      itemStyle: { fontSize: '12px', fontWeight: 'normal', color: colors.black75 },
    },
    xAxis: {
      categories: entityRows.map((r) => r.name),
      lineColor: colors.black10,
      tickLength: 0,
      labels: { style: { fontSize: '11px', color: colors.black75 } },
    },
    yAxis: {
      title: { text: undefined },
      gridLineColor: colors.black10,
      allowDecimals: yAxisAllowDecimals,
      labels: {
        ...(yAxisFormat ? { format: yAxisFormat } : {}),
        style: { fontSize: '11px', color: colors.black50 },
      },
    },
    tooltip: {
      backgroundColor: colors.chartTooltipBackground,
      style: { color: colors.white },
      padding: 12,
      ...(tooltipFormatter ? { formatter: tooltipFormatter } : {}),
    },
    plotOptions: {
      column: {
        borderRadius: { radius: 3, scope: 'point' as const, where: 'end' as const },
        pointWidth: 40,
      },
      series: { animation: false },
    },
    series: [
      {
        type: 'column',
        name: seriesName,
        data: entityRows.map((r) => r.value),
        color,
      },
    ],
  };
}
